import { useCallback, useEffect, useState } from "react";
import { useSignalR } from "../SignalR/SignalRContext";
// InfoHub contract
const STATUS_EVENT = "StarlinkStatus";
const GET_STATUS_METHOD = "GetStarlinkStatus";
const GET_OBSTRUCTION_MAP_METHOD = "GetStarlinkObstructionMap";
const sameDrone = (a, b) => a.toLowerCase() === b.toLowerCase();
function useStarlinkStatus(droneId) {
    const hubConnection = useSignalR();
    const [status, setStatus] = useState(null);
    const [obstructionMap, setObstructionMap] = useState(null);
    const [isMapLoading, setIsMapLoading] = useState(false);
    const [error, setError] = useState(null);
    const applyStatus = useCallback((model) => {
        if (model && droneId && sameDrone(model.droneId, droneId)) {
            setStatus(model);
        }
    }, [droneId]);
    const refresh = useCallback(async () => {
        if (!hubConnection || !droneId)
            return;
        try {
            setError(null);
            const model = await hubConnection.invoke(GET_STATUS_METHOD, droneId);
            applyStatus(model);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
    }, [hubConnection, droneId, applyStatus]);
    const loadObstructionMap = useCallback(async () => {
        if (!hubConnection || !droneId)
            return;
        try {
            setError(null);
            setIsMapLoading(true);
            const map = await hubConnection.invoke(GET_OBSTRUCTION_MAP_METHOD, droneId);
            setObstructionMap(map !== null && map !== void 0 ? map : null);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
        finally {
            setIsMapLoading(false);
        }
    }, [hubConnection, droneId]);
    useEffect(() => {
        setStatus(null);
        setObstructionMap(null);
    }, [droneId]);
    useEffect(() => {
        if (!hubConnection || !droneId)
            return;
        hubConnection.on(STATUS_EVENT, applyStatus);
        refresh();
        return () => {
            hubConnection.off(STATUS_EVENT, applyStatus);
        };
    }, [hubConnection, droneId, applyStatus, refresh]);
    return {
        status,
        obstructionMap,
        isMapLoading,
        error,
        isConnected: !!hubConnection,
        refresh,
        loadObstructionMap,
    };
}
export default useStarlinkStatus;
